module.exports = __webpack_public_path__ + "static/media/logo.b039fc3d.png";